import { PRODUCT_TYPES } from '@src/quince-site-common/src/domains/Product/BundleProduct'
import ProductTag from '@src/quince-site-common/src/domains/ProductTag'
import { useWishList } from '@src/quince-site-common/src/hooks/useWishList'
import classnames from 'classnames'
import { FC, SyntheticEvent, useEffect, useState } from 'react'
import { IconButton } from '../../../atoms'
import HeartIcon from '../icons/heartIcon.inline.svg'
import { useProductCardContext } from '../product-card-context/product-card.context'
import styles from './add-to-wishlist.module.scss'

export const ProductCardAddToWishlist: FC<{
  wishlistIconClassName?: string
  wishlistTrackConfig?: any
  applicableTags?: ProductTag[] | undefined
}> = props => {
  const { product, selectedOptions, siteSearchQuery, productPosition } = useProductCardContext()
  const [isWishListed, setIsWishListed] = useState(false)
  const { isItemInWishList, addItemToWishList, removeItemFromWishList } = useWishList()

  useEffect(() => {
    setIsWishListed(isItemInWishList(product, selectedOptions))
  }, [product.id, selectedOptions])

  const onWishListToggle = async (event: SyntheticEvent) => {
    event.preventDefault()
    event.stopPropagation()
    setIsWishListed(p => !p)
    if (isWishListed) {
      await removeItemFromWishList(product, selectedOptions, undefined, props.wishlistTrackConfig, props.applicableTags)
    } else {
      await addItemToWishList(
        product,
        selectedOptions,
        'product_card',
        productPosition,
        siteSearchQuery,
        props.wishlistTrackConfig,
        props.applicableTags,
      )
    }
  }
  if (product.type === PRODUCT_TYPES.BUNDLE) return null
  return (
    <IconButton
      className={classnames(props.wishlistIconClassName, styles.button)}
      iconClassName={classnames(styles.icon, {
        [styles.whiteIcon]: !isWishListed,
        [styles.blackIcon]: isWishListed,
      })}
      iconSvg={HeartIcon}
      onClick={e => {
        void onWishListToggle(e)
        return
      }}
      ariaLabel={isWishListed ? 'Remove from wishlist' : 'Add to wishlist'}
    />
  )
}
